import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import * as actions from '../actions';
import { selectors } from '../reducer';
import * as Styled from '../SideBar.styles';
import { openNotification, NOTIFICATIONS_CONFIG } from '../../../global/notifications';

const UploadModal = () => {
  const dispatch = useDispatch();

  const [password, setPassword] = useState('');
  const [file, setFile] = useState(null);

  const isModalVisible = useSelector(selectors.uploadFileOpen);
  const listFiles = useSelector(selectors.uploadedFilesList);

  useEffect(() => {
    dispatch(actions.getUploadedFilesList.request());
  }, []);

  const handleCloseModal = () => {
    dispatch(actions.openUploadFilesModal(false));
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      openNotification({
        type: NOTIFICATIONS_CONFIG.types.warning,
        message: 'Please select file',
      });
      return;
    }

    dispatch(
      actions.uploadFile.request({
        file,
        password,
      }),
    );
  };

  const deleteFile = (fileName) => {
    dispatch(actions.deleteFile.request({ sheet: fileName }));
  };

  return (
    <Styled.UploadModal
      title="Upload File"
      open={isModalVisible}
      onCancel={handleCloseModal}
      footer={null}
    >
      <Styled.SideBarInputHeading>Enter Password</Styled.SideBarInputHeading>
      <Styled.SideBarInput
        type="password"
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Styled.UploadButton htmlFor="file-upload">Choose File</Styled.UploadButton>
      <Styled.FileInputContainer>
        <Styled.HiddenFileInput
          type="file"
          id="file-upload"
          accept=".xlsx"
          onChange={handleFileChange}
        />
        <Styled.StyledFileButton onClick={handleUpload}>Upload</Styled.StyledFileButton>
        {listFiles.map((item, index) => (
          <Styled.FileItemContainer key={item}>
            <Styled.FileIndex>{index + 1}.</Styled.FileIndex>
            <Styled.FileName>{item}</Styled.FileName>
            <Styled.DeleteIcon
              onClick={(e) => {
                e.stopPropagation();
                deleteFile(item);
              }}
            >
              <DeleteOutlined />
            </Styled.DeleteIcon>
          </Styled.FileItemContainer>
        ))}
        {file && <Styled.FileNameDisplay>{file.name}</Styled.FileNameDisplay>}
      </Styled.FileInputContainer>
    </Styled.UploadModal>
  );
};

export default UploadModal;
